/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

export const FlexContext = createContext< {
	flexItemDisplay: 'block' | undefined;
} >( {
	flexItemDisplay: undefined,
} );

export const useFlexContext = () => useContext( FlexContext );
